import React, { useEffect, useRef } from 'react';
import './Cancellation.css';

const Cancellation = () => {
  const cancelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-active');
          } else {
            entry.target.classList.remove('reveal-active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = cancelRef.current.querySelectorAll('.animate-cancel');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const policyData = [
    {
      step: "01",
      title: "Easy Cancellation",
      desc: "Cancel anytime up to 2 hours before the scheduled appointment for full refund.",
      icon: "🖱️"
    },
    {
      step: "02",
      title: "Refund Process",
      desc: " Refunds processed within 24 hours automatically to your original payment method.",
      icon: "⏳"
    },
    {
      step: "03",
      title: "Nominal Charges",
      desc: "Late cancellations may incur deposit loss as per our cancellation policy.",
      icon: "🎫"
    }
  ];

  return (
    <section className="cancel-section" id="cancellation" ref={cancelRef}>
      <div className="cancel-container">
        <div className="cancel-header animate-cancel">
          <span className="tag">Policies</span>
          <h2>Cancellation & <span>Refund Policy</span></h2>
          <div className="line-accent"></div>
        </div>

        <div className="policy-flow">
          {policyData.map((item, index) => (
            <div key={index} className={`policy-item animate-cancel delay-${index}`}>
              <div className="step-circle">
                <span className="step-num">{item.step}</span>
                <div className="icon-wrap">{item.icon}</div>
              </div>
              <div className="policy-text">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
              {index !== policyData.length - 1 && <div className="flow-arrow"></div>}
            </div>
          ))}
        </div>

        <div className="policy-footer animate-cancel delay-3">
          <p>For more details, please read our full <strong>Terms & Conditions</strong> or contact support.</p>
        </div>
      </div>
    </section>
  );
};

export default Cancellation;